"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCallPopupState = void 0;
exports.defaultCallPopupState = {
    active: false,
    callUsAt: "Call us at",
    callNumber: "+852 210 20888",
    callPopupTitle: 'Office Hours',
    officeHours: [{ day: 'MONDAY – FRIDAY', time: '9AM - 6PM' },
        { day: 'SATURDAY', time: '9AM to 1PM' },
        { day: 'SUNDAY', time: 'Closed' }]
};
